import { errorMessage, isApiError } from "@/api/client";

/**
 * Splits an API failure into per-field messages (from `error.details.fieldErrors`, as the
 * backend sends for 409/422) and a general message for everything else.
 */
export function formErrorsFrom(err: unknown): { fields: Record<string, string>; form: string | null } {
  const fe = isApiError(err) ? (err.details as { fieldErrors?: Record<string, string> } | undefined)?.fieldErrors : undefined;
  if (fe && Object.keys(fe).length) return { fields: fe, form: null };
  return { fields: {}, form: errorMessage(err) };
}
